<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Dashboard</h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                    <div class="form-group row">
                        <div class="col-md-3 col-sm-12">
                            <base-input>
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="{ allowInput: true }"
                                    class="form-control datepicker"
                                    v-model="startDate"
                                >
                                </flat-picker>
                            </base-input>
                        </div>

                        <div class="col-md-3 col-sm-12">
                            <base-input>
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="{ allowInput: true }"
                                    class="form-control datepicker"
                                    v-model="endDate"
                                >
                                </flat-picker>
                            </base-input>
                        </div>
                        <div class="col-md-5 col-sm-12">
                            <base-button
                                size="md"
                                type="primary"
                                @click="handleSearch()"
                            >
                                Search
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_unpaid')"
                        type="gradient-red"
                        :sub-title="Unpaid"
                        icon="ni ni-active-40"
                    >
                    </stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_awaiting_shipment')"
                        type="gradient-orange"
                        :sub-title="AwaitingShipment"
                        icon="ni ni-chart-pie-35"
                    >
                    </stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_awaitingcollection')"
                        type="gradient-info"
                        :sub-title="AwaitingCollection"
                        icon="ni ni-money-coins"
                    >
                    </stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_intransit')"
                        type="gradient-green"
                        :sub-title="InTransit"
                        icon="fa fa-truck"
                    >
                    </stats-card>
                </div>
				<div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_delivered')"
                        type="gradient-green"
                        :sub-title="Delivered"
                        icon="ni ni-chart-bar-32"
                    >
                    </stats-card>
                </div>
				<div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_completed')"
                        type="gradient-green"
                        :sub-title="Completed"
                        icon="fa fa-check"
                    >
                    </stats-card>
                </div>
				<div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_cancelled')"
                        type="gradient-red"
                        :sub-title="Cancel"
                        icon="fa fa-trash"
                    >
                    </stats-card>
                </div>
				<div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_returned')"
                        type="gradient-red"
                        :sub-title="Returned"
                        icon="fa fa-window-close"
                    >
                    </stats-card>
                </div>
				<div class="col-xl-3 col-md-6">
                    <stats-card
                        :title="$t('order_status_claimed')"
                        type="gradient-orange"
                        :sub-title="Claim"
                        icon="fa fa-exclamation-triangle"
                    >
                    </stats-card>
                </div>
            </div>
        </base-header>
    </div>
</template>
<script>
// Charts
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import StatsCard from "@/components/Cards/StatsCard";
import { mapActions } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

export default {
    components: {
        StatsCard,
        flatPicker
    },
    data() {
        return {
            startDate: "",
            endDate: "",

            AwaitingCollection: "",
            AwaitingShipment: "",
            Cancel: "",
            Claim: "",
            Completed: "",
            Delivered: "",
            InTransit: "",
            PartiallyShipping: "",
            Returned: "",
            Unpaid:"",
        };
    },
    methods: {
        ...mapActions({
            listData: "Report/listReportDashboard"
        }),
        async handleSearch() {
            let params = {
                time_from: this.startDate,
                time_to: this.endDate,
                platform_id: 1
            };

            try {
                let response = await this.listData(params);
				let status = response.data.Datum.Status
				this.AwaitingCollection =  status.AwaitingCollection.toString()
				this.AwaitingShipment =  status.AwaitingShipment.toString()
				this.Cancel =  status.Cancel.toString()
				this.Claim =  status.Claim.toString()
				this.Completed =  status.Completed.toString()
				this.Delivered =  status.Delivered.toString()
				this.InTransit =  status.InTransit.toString()
				this.Returned =  status.Returned.toString()
				this.Unpaid =  status.Unpaid.toString()
            } catch (err) {
                swal.fire({
                    text: err.response.data.Msg,
                    title: "err.",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            }
        }
    },
    mounted() {
        this.startDate = moment()
            .add(-7, "days")
            .format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
        this.handleSearch();
    }
};
</script>
<style></style>
